module.exports = __webpack_public_path__ + "static/media/land-definition-bg.306b7507.png";